
const state = {
  fontSizeLevel: 'MEDIUM' // SMALL, MEDIUM, LARGE
}

const getters = {}

const mutations = {
  UPDATE_FONTSIZE_LEVEL: (state, data) => {
    state.fontSizeLevel = data.toUpperCase()
  }
}

const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
